import BasicLayout from '@/layouts/basic-layout'

const prefix = 'storage-manage-supplementary-provisions-'
export default [
  {
    path: '/storage-manage/supplementary-provisions',
    redirect: {name: `${prefix}index`},
    component: BasicLayout,
    children: [
      {
        path: 'index',
        name: `${prefix}index`,
        meta: {title: '业主补充条款管理'},
        component: () => import('@/pages/storage-manage/supplementary-provisions/index')
      },
      {
        path: 'detail-edit/:id',
        name: `${prefix}edit`,
        auth: ['hidden'],
        meta: {cache: true, title: '业主补充条款编辑'},
        component: () => import('@/pages/storage-manage/supplementary-provisions/detail-edit')
      },
      {
        path: 'detail-view/:id',
        name: `${prefix}view`,
        auth: ['hidden'],
        meta: {title: '业主补充条款详情'},
        component: () => import('@/pages/storage-manage/supplementary-provisions/detail-view')
      },
      {
        path: 'sublease-detail-view/:id',
        name: `${prefix}sublease-detail-view`,
        auth: ['hidden'],
        meta: {title: '业主补充条款详情'},
        component: () => import('@/pages/storage-manage/supplementary-provisions/sublease-detail-view')
      }
    ]
  }
]
